import { CUSTOMER_TYPE_BUSINESS } from 'shared/constants'
import featureToggles from 'shared/featureToggles'
import { formatToGrs } from 'shared/time-utilites'
import { GOOGLE_PAY_METHOD, PIX_PAYMENT_METHOD, PSE_PAYMENT_METHOD } from 'shared/transactions'

export const mapBoletoData = boletoData => {
    if (!boletoData) {
        return {}
    }

    const {
        documentNumber: CustomerDocumentNumber,
        postalCode: PostalCode,
        street: Street,
        streetNumber,
        district: District,
        city: City,
        state: State,
        complement: Complement,
    } = boletoData

    return {
        BOLETOPAYMENTINFO: {
            CustomerDocumentType: CUSTOMER_TYPE_BUSINESS,
            CustomerDocumentNumber,
            PostalCode,
            Street,
            Number: streetNumber,
            District,
            City,
            State,
            Complement,
        },
    }
}

export const generateReservationList = ({
    items,
    userDetails,
    selectedVehicleDetails,
    apiLanguageCode,
    card,
    googlePayFields,
    boletoData,
    startedWithProductId,
    inboundNumber,
    outboundNumber,
    additionalServices,
    PIX,
    GOOGLE_PAY,
    reservationId,
    PSE,
}) =>
    items.map(item => {
        const { rate, vehicles, promoCode, autoRenew } = item
        const {
            eDataLocationId: locationId,
            rateId,
            fromDate,
            toDate,
            actualFromDateISO,
            actualToDateISO,
            actualFromDate,
            actualToDate,
            waitingListKey,
            eventId,
            defaultCustomerFlow,
        } = rate
        const { id: vehicleId, state } = vehicles[0] || {}

        const { firstName, lastName, phone, address, deliveryAddress: delivery, billingAddress } = userDetails

        const email = userDetails?.emailAddress || userDetails?.email

        const { id: ccId, cardLast4, name: ccName, cardType, expDate, token } = card || {}

        const googlePayParams = GOOGLE_PAY
            ? {
                  CARTPAYMENTUPDATEINFO: {
                      GoogleAPIFields: googlePayFields,
                  },
              }
            : {}

        const threeDsParams = featureToggles.has3dsPayment
            ? {
                  BROWSERCOLORDEPTH: screen.colorDepth,
                  BROWSERJAVAENABLED: navigator.javaEnabled(),
                  BROWSERLANGUAGE: navigator.language,
                  BROWSERSCREENHEIGHT: screen.height,
                  BROWSERSCREENWIDTH: screen.width,
                  BROWSERTIMEZONE: new Date().getTimezoneOffset(),
                  ENABLE3DS: true,
              }
            : {}

        const pseParams = PSE
            ? {
                  LCLPMTOPTN: {
                      Option: PSE_PAYMENT_METHOD,
                      BankCode: PSE,
                  },
              }
            : {}

        return {
            EVENTID: eventId ? eventId : undefined,
            LOC: locationId,
            RATEID: rateId,
            FD: formatToGrs(fromDate),
            TD: formatToGrs(toDate),
            ACTUALFDATE: actualFromDateISO || formatToGrs(actualFromDate),
            ACTUALTODATE: actualToDateISO || formatToGrs(actualToDate),
            EM: email,
            VEHID: vehicleId,
            LP: selectedVehicleDetails.tag,
            STATE: state,
            VMDL: selectedVehicleDetails.model,
            VMKE: selectedVehicleDetails.make,
            LPS: selectedVehicleDetails.state,
            VCLR: selectedVehicleDetails.color,
            VEHLIST: vehicles.length > 1 ? vehicles.map(parseVehicleData) : null,
            WLKEY: waitingListKey,

            PRMCODE: promoCode ? promoCode.barcode : undefined,
            PRMAMT: promoCode ? promoCode.promoDiscount : undefined,
            ISAUTORNW: autoRenew || false,
            ISOLANGCODE: apiLanguageCode,
            WIDGETKEY: window.WIDGET_KEY || 'Web',

            PKRFNAME: firstName,
            PKRLNAME: lastName,
            PKREMAIL: email,
            PKRMOB: phone,
            PKRADDR1: address?.address1,
            PKRADDR2: address?.address2,
            PKRCITY: address?.city,
            PKRSTATE: address?.state,
            PKRZIP: address?.postalCode,
            PKRDISTRICT: billingAddress?.district,
            PKRNUMBER: billingAddress?.streetNumber,

            DLVRYNAME: `${firstName} ${lastName}`,
            DLVRYADDR1: delivery?.address1,
            DLVRYADDR2: delivery?.address2,
            DLVRYCITY: delivery?.city,
            DLVRYSTATE: delivery?.state,
            DLVRYZIP: delivery?.postalCode,
            DLVRDISTRICT: delivery?.district,
            DLVRNUMBER: delivery?.streetNumber,

            CCID: GOOGLE_PAY ? undefined : ccId,
            CRDLAST4: cardLast4,
            CRDNAME: ccName,
            CRDTYPE: cardType,
            SCKEY: WIDGET_TYPE,
            EXP: expDate,
            ...mapBoletoData(boletoData),
            ...(featureToggles.newAuthFlow ? { PN: token } : {}),
            CUSTOMERFLOWTYPE: defaultCustomerFlow,
            STARTEDWITHPRODUCTID: startedWithProductId,
            INBOUNDFLGTNO: inboundNumber,
            OUTBOUNDFLGTNO: outboundNumber,
            RESERVATIONOPTION: additionalServices,
            PMTMHD: PIX ? PIX_PAYMENT_METHOD : PSE ? PSE_PAYMENT_METHOD : undefined,
            ID: reservationId,
            ...threeDsParams,
            ...pseParams,
            ...googlePayParams,
        }
    })

export const guestCheckoutReservationData = (
    token,
    items,
    userDetails,
    selectedVehicleDetails,
    apiLanguageCode,
    inboundNumber,
    outboundNumber,
    PIX,
    nuveiSessionToken,
    PSE,
    GOOGLE_PAY,
    googlePayFields
) => {
    const threeDsParams = featureToggles.has3dsPayment
        ? {
              BROWSERCOLORDEPTH: screen.colorDepth,
              BROWSERJAVAENABLED: navigator.javaEnabled(),
              BROWSERLANGUAGE: navigator.language,
              BROWSERSCREENHEIGHT: screen.height,
              BROWSERSCREENWIDTH: screen.width,
              BROWSERTIMEZONE: new Date().getTimezoneOffset(),
              ENABLE3DS: true,
          }
        : {}

    const pseParams = PSE
        ? {
              LCLPMTOPTN: {
                  Option: PSE_PAYMENT_METHOD,
                  BankCode: PSE,
              },
          }
        : {}

    const googlePayParams = GOOGLE_PAY
        ? {
              CARTPAYMENTUPDATEINFO: {
                  GoogleAPIFields: googlePayFields,
              },
          }
        : {}

    const data = {
        EM: userDetails.email,
        PKREMAIL: userDetails.email,
        ACTUALFDATE: items.rate.actualFromDateISO || formatToGrs(items.rate.actualFromDate),
        WIDGETKEY: window.WIDGET_KEY || 'Web',
        FD: items.rate.actualFromDate || formatToGrs(items.rate.fromDate),
        LOC: items.rate.locationId || items.rate.eDataLocationId,
        ACTUALTODATE: items.rate.actualToDateISO || formatToGrs(items.rate.actualToDate),
        TD: items.rate.actualToDate || formatToGrs(items.rate.toDate),
        RATEID: items.rate.rateId,
        SCKEY: WIDGET_TYPE,
        ISOLANGCODE: apiLanguageCode,
        PN: token,
        LP: selectedVehicleDetails.tag,
        VMKE: selectedVehicleDetails.make,
        VMDL: selectedVehicleDetails.model,
        LPS: selectedVehicleDetails.state,
        VCLR: selectedVehicleDetails.color,
        PKRLNAME: userDetails.lastName,
        PKRFNAME: userDetails.firstName,
        PKRMOB: userDetails.phone,
        OUTBOUNDFLGTNO: outboundNumber,
        INBOUNDFLGTNO: inboundNumber,
        PMTMHD: PIX ? PIX_PAYMENT_METHOD : PSE ? PSE_PAYMENT_METHOD : undefined,
        PRMCODE: items?.promoCode?.barcode || undefined,
        PRMAMT: items?.promoCode?.promoDiscount || undefined,
        CUSTDOCTYPE: userDetails.documentType,
        CUSTDOCNUM: userDetails?.documentNumber?.replace(/\D/g, ''),
        CUSTOMERFLOWTYPE: items.rate.defaultCustomerFlow,
        SSNTKN: nuveiSessionToken,
        EVENTID: items.rate.eventId ? items.rate.eventId : undefined,
        VEHID: null,
        STATE: selectedVehicleDetails.state,
        VEHLIST: null,
        WLKEY: items.rate.waitingListKey ?? null,
        ISAUTORNW: items.autoRenew || false,
        ...threeDsParams,
        ...pseParams,
        ...googlePayParams,
    }

    return [data]
}

export const parseVehicleData = ({ id, state, tag, name, color, make, model }) => ({
    ID: id,
    STATE: state,
    TAG: tag,
    NAME: name,
    COLOR: color,
    MAKE: make,
    MODEL: model,
    VEHID: id,
})
